<template>
    <div>
        <v-card class="card--flex-toolbar" flat>
            <v-tabs color="grey lighten-3" v-model="current_tab" dark slider-color="grey darken-4">
                <v-tab ripple :to="{name: 'AdminWidgetRoot'}" class="grey--text text--darken-4 caption" >{{$t('admin.page.widget.root.navigation.tab.menu.metadata')}}</v-tab>
                <v-tab v-if="widget && widget.type == DEFINES.WIDGETS.TYPE_CONTENT" ripple :to="{name: 'AdminWidgetCustomize'}" class="grey--text text--darken-4 caption" >{{$t('admin.page.widget.root.navigation.tab.menu.customize')}}</v-tab>
            </v-tabs>
        </v-card>
        <v-card v-if="isLoading" height="50vh">
            <v-content class="content-background">
                <v-container fluid fill-height>
                    <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                    </v-flex>
                    </v-layout>
                </v-container>
            </v-content>
        </v-card >
        <router-view
            v-else
            :widget.sync="widget"
        ></router-view>
    </div>
</template>
<script>
import i18n from "@/i18n";
import DEFINES from "@/defines";
export default {
    name: "WidgetRoot",
    data() {
        return {
            current_tab: null,
            isLoading: false,
            tabs: [
                {
                    text: i18n.t('admin.page.widget.root.navigation.tab.menu.metadata'),
                    route_name: 'AdminWidgetRoot'
                },
                {
                    text: i18n.t('admin.page.widget.root.navigation.tab.menu.customize'),
                    route_name: 'AdminWidgetCustomize'
                },
            ],
            widget: {
                name: null,
                content: null,
                image_url:null,
                type: 0,
                related_to: DEFINES.WIDGETS.RELATED_TO_NETFEST,
                screener_ids: [],
                configurations: this.__initWidgetConfigurations(),
                data:this.__initWidgetData(),
                published:false
            },
        }
    },
    mounted() {
        this.get()
    },
    methods: {
        async get(){
            if (this.$route.params.widget_id == undefined) {
                return;
            }
            let result = await this.$store.dispatch("adminWidget/get", {
                id: this.$route.params.widget_id
            });
            var widget = Object.assign({}, result.widget);
            this.widget = widget;

            if(!this.widget.screener_ids){
                this.widget.screener_ids = [];
            }

            if(!this.widget.configurations){
                this.widget.configurations = this.__initWidgetConfigurations(this.widget);
            }
            
            if(!this.widget.data){
                this.widget.data = this.__initWidgetData(this.widget);
            }
            
        },
        __initWidgetConfigurations(widget = null){
            /**
             * For Headers
             */
            if(widget && widget.type == DEFINES.WIDGETS.TYPE_HEADER){
                return {
                    search_bar:false,
                    show_logo:false,
                    copyrights:false,
                    social_media_links:false,
                    show_navigation_links:false
                }
            }

            if(widget && widget.type == DEFINES.WIDGETS.TYPE_FOOTER){
                return {
                    search_bar:false,
                    show_logo:false,
                    copyrights:false,
                    social_media_links:false,
                    show_navigation_links:false,
                    quick_links:false,
                    legal_links:false,
                }
            }

            if(widget && widget.type == DEFINES.WIDGETS.TYPE_CONTENT){
                return {
                    visibility: null
                }
            }


            return null

        },
        __initWidgetData(widget = null){
            if(widget){
                return {
                    copyrights_text:'',
                    social_media_links:{
                        linkedin:'',
                        twitter:'',
                        facebook:'',
                        instagram:'',
                        youtube:'',
                        google_play:'',
                        app_store:''
                    },
                    navigation_links:[
                        this.__makeNavigationLink()
                    ],
                    tags:[],
                    quick_links:[

                    ],
                    legal_links:[

                    ],
                }
            }
        },

        __makeNavigationLink(){
            return {
                'text':'',
                'link':null,
                'target':'_self'
            }
        }
    }
}
</script>
